// extracted by mini-css-extract-plugin
export default {"unableReceive":"unableReceive--gHwcG","voiceConfirmContent":"voiceConfirmContent--F4fHd","markerAnimationScale":"markerAnimationScale--G7r3X"};